module.exports = {"geekSquad":{"label":"Geek Squad","appleProductsIncluded":true,"techSupport":"+$200/2 years","learningWithExperts":false,"signUpTime":"Only at point of sale","cancellationPolicy":"*2 year contract","registerDevices":true},"squareTrade":{"label":"Square Trade","appleProductsIncluded":false,"techSupport":"Not available","learningWithExperts":false,"signUpTime":"Within 30 days of your individual tech purchase","cancellationPolicy":"*2 year contract","registerDevices":true}}


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/resources/calculator/competitors.json
// module id = 3447
// module chunks = 0